import { TableColumnMeta } from "ds/components/Table/types";

export const PLUGINS_COLUMNS_STORAGE_KEY = "plugins-columns";

export enum PLUGINS_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  DESCRIPTION = "DESCRIPTION",
  LABEL_IDENTIFIER = "LABEL_IDENTIFIER",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

export const PLUGINS_COLUMN_CONFIG: Record<PLUGINS_COLUMN_ID, TableColumnMeta> = {
  [PLUGINS_COLUMN_ID.NAME]: {
    id: PLUGINS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.LABELS]: {
    id: PLUGINS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 150,
    defaultWidth: 150,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.DESCRIPTION]: {
    id: PLUGINS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.LABEL_IDENTIFIER]: {
    id: PLUGINS_COLUMN_ID.LABEL_IDENTIFIER,
    title: "Stack label",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.SPACE]: {
    id: PLUGINS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.CREATED_AT]: {
    id: PLUGINS_COLUMN_ID.CREATED_AT,
    title: "Created At",
    minWidth: 160,
    defaultWidth: 160,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [PLUGINS_COLUMN_ID.DROPDOWN]: {
    id: PLUGINS_COLUMN_ID.DROPDOWN,
    title: "Plugin actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
